import {
  CommentContextClient,
  ClientOutput,
  ClientInput,
} from '../../Clients/Comments/CommentContextClient';
import {
  call,
  put,
  select,
  CallEffect,
  PutEffect,
  SelectEffect,
} from 'redux-saga/effects';
import { ApiGetter } from '../../Clients/ApiGetter';
import { actions } from '../../../reducers/CommentHistory/CommentContexts';
import { State as ControlsState } from '../../../reducers/CommentHistory/Controls';
import { controlsSelector } from '../../../selectors/CommentHistory/Controls';

export const commentContextClient = new CommentContextClient(new ApiGetter());

export function* getCommentContexts(): Generator<
  CallEffect | PutEffect,
  void,
  ClientInput | ClientOutput
> {
  const input = (yield call(getCommentContextsInput)) as ClientInput;

  const { data, error } = (yield call(
    [commentContextClient, commentContextClient.retrieveAsync],
    input
  )) as ClientOutput;

  if (error || !data) {
    yield put(actions.setCommentContextResult([], 0));
    return;
  }

  yield put(
    actions.setCommentContextResult(
      data.commentContexts,
      data.totalCommentCount
    )
  );
}

export function* getCommentContextsInput(): Generator<
  SelectEffect,
  ClientInput,
  ControlsState
> {
  const {
    organizationUUID,
    dateRange,
    commentType,
    severity,
    category,
    author,
    repositoryUUID,
    page,
    sortBy,
  }: ControlsState = yield select(controlsSelector);

  if (commentType === 'inline') {
    return {
      organizationUUID: organizationUUID || '',
      dateRange,
      commentType,
      severity,
      category,
      author,
      repositoryUUID,
      page,
      sortBy,
    };
  }

  return {
    organizationUUID: organizationUUID || '',
    dateRange,
    commentType,
    author,
    repositoryUUID,
    page,
    sortBy,
  };
}
